import React, { useMemo, useState, useEffect } from "react";
import ContactInfo from "./ContactInfo/ContactInfo";
import MediaLinks from "./MediaLinks/MediaLinks";
import ScheduleMessage from "./ScheduleMessage/ScheduleMessage";
import AddGroupMember from "./AddGroupMember/AddGroupMember";
import EditChannelComponent from "./EditChannelComponent/EditChannelComponent";
import { putApiCaller, getApiCaller } from "../../../Libs/apiCaller";
import { toast } from "react-toastify";
import UserViewComponent from "../../../Components/UserViewComponent/UserViewComponent";

export default function ChannelProfileView({
  settings,
  setSettings,
  activeChannel,
  setActiveChannel,
  setAllMessages,
  activeSection,
  setActiveSection,
  setShowProfileView,
  showAddGroupMember,
  setShowAddGroupMember,
  fetchChannels,
  setChannels,
}) {
  const [showEditChannel, setShowEditChannel] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isViewing, setIsViewing] = useState(false);
  const [allUserCurrentPage, setAllUserCurrentPage] = useState(1);
  const [allUserTotalPages, setAllUserTotalPages] = useState(1);

  const [allUser, setAllUser] = useState([]);

  useEffect(() => {
    fetchAllUser(1, "");
  }, [showAddGroupMember]);

  const fetchAllUser = async (page = allUserCurrentPage, search) => {
    const endpoint = `users/all_user_app?page=${page}&limit=20&search=${search}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      const remainingUsers = response.data.users.filter(
        (user) => !activeChannel.users.some((u) => u._id === user._id)
      );
      setAllUser((prev) =>
        page == 1 ? remainingUsers : [...prev, ...remainingUsers]
      );
      setAllUserCurrentPage(response.data.pagination.currentPage);
      setAllUserTotalPages(response.data.pagination.totalPages);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const newusers = useMemo(() => {
    if (!activeChannel || !allUser) return [];
    const currentUserIds = activeChannel?.users.map((user) => user._id);
    return allUser.filter((user) => !currentUserIds.includes(user._id));
  }, [allUser, activeChannel]);

  const updateChannel = async (newChannelDetails, details = null) => {
    const endpoint = `channel/update/${activeChannel._id}`;
    const response = await putApiCaller(endpoint, newChannelDetails);
    if (response) {
      setActiveChannel((prev) => ({
        ...prev,
        ...(details ? details : newChannelDetails),
      }));
      fetchChannels(true);
      toast.success("Channel updated successfully");
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
    setShowEditChannel(false);
  };

  const addUser = async (selectedUsers) => {
    const endpoint = `channel/${activeChannel._id}/add-user`;
    const response = await putApiCaller(endpoint, {
      users: selectedUsers.map((user) => user._id),
    });
    if (response) {
      toast.success("User added successfully");
      fetchChannels(true);
      setShowAddGroupMember(false);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  return (
    <section className="w-full">
      {activeSection === "contact" &&
        !isViewing &&
        !showAddGroupMember &&
        !showEditChannel && (
          <ContactInfo
            fetchChannels={fetchChannels}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            setIsViewing={setIsViewing}
            settings={settings}
            setSettings={setSettings}
            updateChannel={updateChannel}
            allUser={allUser}
            activeChannel={activeChannel}
            setActiveChannel={setActiveChannel}
            setActiveSection={setActiveSection}
            setShowProfileView={setShowProfileView}
            toggleAddGroupMember={() =>
              setShowAddGroupMember(!showAddGroupMember)
            }
            isAdmin={true}
            setShowEditChannel={setShowEditChannel}
            setChannels={setChannels}
            setAllMessages={setAllMessages}
          />
        )}

      {isViewing && (
        <UserViewComponent
          user={selectedUser}
          onBack={() => {
            setIsViewing(false);
            setSelectedUser(null);
          }}
        />
      )}

      {showEditChannel && (
        <EditChannelComponent
          setActiveChannel={setActiveChannel}
          activeChannel={activeChannel}
          setShowEditChannel={setShowEditChannel}
          setActiveSection={setActiveSection}
          setShowAddGroupMember={setShowAddGroupMember}
          handleDone={updateChannel}
        />
      )}

      {/* Toggle between Contact Info and Add Group Member */}
      {showAddGroupMember && (
        <AddGroupMember
          allUser={newusers}
          setActiveSection={setActiveSection}
          showAddGroupMember={showAddGroupMember}
          setShowAddGroupMember={setShowAddGroupMember}
          addUser={addUser}
          fetchAllUser={fetchAllUser}
          allUserCurrentPage={allUserCurrentPage}
          allUserTotalPages={allUserTotalPages}
        />
      )}

      {activeSection === "media" && (
        <MediaLinks
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
        />
      )}

      {activeSection === "schedule" && (
        <ScheduleMessage
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
        />
      )}
    </section>
  );
}
